import fetch from "./fetch";
let HEALTHAPI=  process.env.VUE_APP_HEALTH_API;
const {
  VUE_APP_LAIKANG_API,
  VUE_APP_H5_API
} = process.env
console.log('当前环境process.env===',process.env)
// 登录后去token
export function getToken(params) {
  return fetch({
    url: '/lk_oauth/oauth/token',
    method: 'post',
    type: 'FORMDATA',
    params
  })
}
// 获取用户ID
export function getUserId() {
  return fetch({
    url: '/lk_uc/v1/user/me',
    method: 'get'
  })
}
// 加密/解密用户id;
export function getUserIdEncrypt(params) {
  return fetch({
	contentType: 'application/json',
	baseUrl: HEALTHAPI,
	header:{
		authorization: uni.getStorageSync ('authorization')
	},
    url: '/customer/getUserIdEncrypt',
    method: 'POST',
	params
  })
}

// 通过用户id获取用户熵值详细信息
export function getUserEntropy(params) {
	return fetch({
		baseUrl: HEALTHAPI,
		contentType: "application/json",
		url: "/entropy/getUserEntropy",
		method: "POST",
		params,
	});
}

// 获取用户签名
export function getUseSign(params) {
  return fetch({
    url: '/lk_im/userSig/generateUserSig',
    method: 'get',
    params
  })
}

// 微信小程序登陆接口;
export function getUserInfo(params) {
  return fetch ({
	baseUrl: HEALTHAPI,
    url: '/auth/wxLogin',
    method: 'POST',
    params,
  });
}
//获取im用户签名;
export function generateUserSig(params) {
  return fetch ({
	baseUrl: HEALTHAPI,
	header:{
		authorization: uni.getStorageSync ('authorization')
	},
    url: '/im/generateUserSig',
    method: 'GET',
    params,
  });
}
// 创建群组接口
export function createGroup(params) {
  return fetch ({
    baseUrl: HEALTHAPI,
    url: '/im/createGroup',
    method: 'POST',
    params,
  });
}
//微信获取手机号
export function getUserPhoneNumber(params) {
  return fetch ({
    baseUrl: HEALTHAPI,
    url: '/wxApi/getUserPhoneNumber',
    method: 'POST',
    params,
  });
}
//C端查询用户基本信息
export function getBaseUserInfo(params) {
  return fetch ({
    baseUrl: HEALTHAPI,
    url: '/customer/getBaseUserInfo',
    method: 'GET',
    params,
  });
}
//五师端查询医生基本信息--查询客户简单信息
export function getDoctorUserInfo(params) {
  return fetch({
    baseUrl: HEALTHAPI,
    url: "/customer/simple/info",
    method: 'GET',
    params,
  });
}
//五师端查询用户基本信息
export function getCustomerUserInfo(params) {
  return fetch({
    baseUrl: HEALTHAPI,
    url: '/customer/info',
    method: 'get',
    params,
  });
}
//五师端查询医生基本信息--查询客户简单信息
export function getStaffUserInfo(params) {
  return fetch({
    baseUrl: HEALTHAPI,
    url: '/staff/info',
    method: 'get',
    params,
  });
}
//C端修改用户基本信息接口
export function modify(params) {
  return fetch ({
    contentType:"application/json",
    baseUrl: HEALTHAPI,
    url: '/customer/modify',
    method: 'POST',
    params,
  });
}
//查询系统配置列表;
export function getConfigList(params) {
  return fetch ({
    contentType: 'application/json',
    baseUrl: HEALTHAPI,
    url: '/config/getConfigList',
    method: 'POST',
	params
  });
}
//查询系统配置;
export function getConfig(params) {
  return fetch({
		baseUrl: HEALTHAPI,
		contentType: "application/json",
    url: `/config/getConfig${params.configKey ? `/${params.configKey}` : ''}`,
		method: "POST",
		params,
	});
}
//手动结束咨询
export function endConsult (params) {
  return fetch ({
	header:{
		authorization: uni.getStorageSync ('authorization')
	},
    baseUrl: HEALTHAPI,
    url: '/consult/endConsult',
    method: 'POST',
    params,
  });
}
//获取群组聊天记录;
export function getGroupChatRecord (params) {
  return fetch ({
    contentType: 'application/json',
    baseUrl: HEALTHAPI,
	header:{
		authorization: uni.getStorageSync ('authorization')
	},
    url: '/im/getGroupChatRecord',
    method: 'POST',
    params,
  });
}
//健康宣教检索
export function healthMission (params) {
  return fetch ({
    contentType: 'application/json',
    baseUrl: VUE_APP_LAIKANG_API,
    url: '/healthMission/search',
    method: 'POST',
    params,
  });
}
//查询聊天记录月份分组
export function getGroupChatRecordGroup (params) {
  return fetch ({
	header:{
		authorization: uni.getStorageSync ('authorization')
	},
    baseUrl: HEALTHAPI,
    url: '/im/getGroupChatRecordGroup',
    method: 'POST',
    params,
  });
}
//既往疾病史
export function diseaseHistory (params) {
  return fetch ({
    header:{
      authorization: uni.getStorageSync ('authorization')
    },
	contentType: 'application/json',
    baseUrl: HEALTHAPI,
    url: '/vitalSign/diseaseHistory',
    method: 'POST',
    params,
  });
}

//查询健康促进方案
export function getCustomer (params) {
  return fetch ({
    header: {
      authorization: uni.getStorageSync ('authorization'),
    },
	contentType: 'application/json',
    baseUrl: HEALTHAPI,
    url: '/healthPlan/getHealthPlan/customer',
    method: 'POST',
    params,
  });
}
//是否显示下一期按钮;
export function showNextButton (params) {
  return fetch ({
    header: {
      authorization: uni.getStorageSync ('authorization'),
    },
    contentType: 'application/json',
    baseUrl: HEALTHAPI,
    url: '/healthPlan/showNextButton/customer',
    method: 'POST',
    params,
  });
}

//宣教详情接口;
export function getEducationInfo (params) {
  return fetch ({
    baseUrl: HEALTHAPI,
    url: '/knowledge/getEducation/'+ params,
    method: 'GET',
  });
}

//是否展示知情同意书;
export function showAgreement (params) {
  return fetch ({
    contentType: 'application/json',
    baseUrl: HEALTHAPI,
    url: '/agreement/showAgreement',
    method: 'POST',
    params,
  });
}
//同意知情同意书
export function showConfirm (params) {
  return fetch ({
    contentType: 'application/json',
    baseUrl: HEALTHAPI,
    url: '/agreement/confirm',
    method: 'POST',
    params,
  });
}
//查询群组列表/查询群成员列表
export function getGroupList(params) {
  return fetch({
    contentType: 'application/json',
    baseUrl: HEALTHAPI,
    url: '/groupChat/getGroupList',
    method: 'POST',
    params,
  });
}
//按机构邀请专家
export function inviteDoctor(params) {
  return fetch({
    contentType: 'application/json',
    baseUrl: HEALTHAPI,
    url: '/invite/doctor',
    method: 'POST',
    params,
  });
}
/**
 * 订单生成方案-获取默认收获地址
 * @param {*} params 
 * @param {number} params.userId  用户id
 * @returns 
 */
export function addressGet(params) {
  return fetch({
    // contentType: 'application/json',
    baseUrl: VUE_APP_H5_API,
    url: '/address/get',
    method: 'GET',
    params,
  });
}
/**
 * 订单生成方案
 * @param {object} params 
 * @param {number} params.userId  用户id
 * @returns 
 */
export function orderRecommond(params) {
  return fetch({
    contentType: 'application/json',
    baseUrl: VUE_APP_H5_API,
    url: '/sku/get/order/recommond',
    method: 'POST',
    params,
  });
}
//获取群组基本信息
export function getGroupInfo(params) {
  return fetch({
    contentType: 'application/json',
    baseUrl: HEALTHAPI,
    url: '/groupChat/getGroupInfo',
    method: 'GET',
    params,
  });
}
// 获取关系网数据
export function getFamilyRelation(params) {
  return fetch({
    contentType: 'application/json',
    baseUrl: HEALTHAPI,
    url: '/friend/getFamilyRelation',
    method: 'GET',
    params,
  });
}

// 搜索用户
export function searchUser(params) {
	return fetch({
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		url: "/customer/searchUser",
		method: "post",
		params,
	});
}

// 添加好友申请
export function inviteFriend(params) {
	return fetch({
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		url: "/friend/inviteFriend",
		method: "post",
		params,
	});
}
// 查询微太血糖仪绑定状态
export function getWettaiBindStatus(params) {
	return fetch({
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		url: "/cgm/hospital/wettai/bind/status",
		method: "post",
		params,
	});
}

export function enableWettaiBind(params) {
	return fetch({
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		url: "/cgm/hospital/wettai/enable",
		method: "post",
		params,
	});
}

export function disableWettaiByGroup(params) {
	return fetch({
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		url: "/cgm/hospital/wettai/disableByGroup",
		method: "post",
		params,
	});
}